
export const DELIVER_ORDER= 'DELIVER_ORDER'
export const DELIVER_ORDER_SUCCESS= 'DELIVER_ORDER_SUCCESS'
export const DELIVER_ORDER_ERROR='DELIVER_ORDER_ERROR'


export const DeliverOrder= (data) => ({
    type: DELIVER_ORDER,
    payload: data
});